<template>

    <div :key="getCurrentRoomId" class="view">

        <div class="d-flex flex-column flex-grow-1 relative">

            <transition :name="transition">

                <keep-alive >
                    <component v-bind:is="currentView.name" :changeView="changeView" :params="view.params"/>
                </keep-alive>

            </transition>

        </div>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";
    import chatMainList from './list.vue';

    export default {
        name: 'chatMain',
        components: {
            'list-view': chatMainList
        },
        data() {
            return {
                visit_id: 0,
                view: {
                    name: 'list-view',
                    params: {}
                },
                transition: 'next'
            }
        },
        methods: {
            changeView({view, params}) {
                this.view.name = view;
                this.view.params = params || {};
            }
        },
        computed: {
            ...mapGetters('chat', ['getCurrentRoomId']),
            currentView: function() {

                this.transition = (this.view.name === 'list-view') ? 'prev' : 'next';

                return this.view;
            }
        }
    }
</script>

<style scoped>


</style>
